var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.groups),function(group,index){return _c('div',{key:index,staticClass:"my-3 white"},[_c('v-container',[_c('div',{staticClass:"sl-title"},[_vm._v(_vm._s(_vm._f("cates")([group.cate])))]),_c('BizList',{attrs:{"bizs":group.bizs}})],1)],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }